.pos-relative{height:auto}
/*# sourceMappingURL=summary-rules-content.component-YCBVR3M4.css.map */
